import React from "react";
import { FieldValues, UseFormReturn, useWatch } from "react-hook-form";
import { FieldType, FormField, TextObject } from "@/shared/types";
import CheckboxInput from "../../components/CheckboxInput/CheckboxInput";
import RadioInput from "../../components/RadioInput/RadioInput";
import SelectInput from "../../components/SelectInput/SelectInput";

interface SelectableFieldProps {
  isError?: boolean;
  field: FormField;
  useFormProps: UseFormReturn<FieldValues, any>;
  isSubmitting: boolean;
  text: TextObject;
}

const SelectableField: React.FC<SelectableFieldProps> = ({
  isError,
  useFormProps,
  field,
  text,
}) => {
  const selectedOptions = useWatch({
    control: useFormProps?.control,
    name: field?.id,
  });

  if (field?.type === FieldType.Checkbox)
    return (
      <CheckboxInput
        isError={isError}
        fieldSettings={field?.settings || {}}
        registerProps={{
          ...useFormProps?.register(field?.id),
        }}
        selectedOptions={selectedOptions}
        text={text}
      />
    );

  if (field?.type === FieldType.Radio)
    return (
      <RadioInput
        isError={isError}
        fieldSettings={field?.settings || {}}
        registerProps={{
          ...useFormProps?.register(field?.id),
        }}
        text={text}
      />
    );

  if (field?.type === FieldType.Select)
    return (
      <SelectInput
        isError={isError}
        fieldSettings={field?.settings || {}}
        selectedOptions={selectedOptions}
        registerProps={{
          ...useFormProps?.register(field?.id),
        }}
        control={useFormProps?.control}
        text={text}
      />
    );

  return null;
};

export default SelectableField;
